import * as types from '../../components/Question/types';
import * as mathSymbols from '../../mathSymbols';

export const halvesQuestions: types.Question[] = [
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 1, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 2, answer: 11, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 1, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 2, answer: 11, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 2, answer: 1, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 4, answer: 2, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 6, answer: 3, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 8, answer: 4, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 10, answer: 5, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 12, answer: 6, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 14, answer: 7, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 16, answer: 8, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 18, answer: 9, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 20, answer: 10, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 22, answer: 11, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question,
  {
    numA: 24, answer: 12, action: 'Half', format: types.Format.WordEquation, hint: types.Hint.BAR_MODEL
  } as types.Question
];

export const divide2Questions: types.Question[] = [
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 2, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 2, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question
];

export const divide5Questions: types.Question[] = [
  {
    numA: 5, sign: mathSymbols.DIV, numB: 5, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 5, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.DIV, numB: 5, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 5, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.DIV, numB: 5, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 5, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.DIV, numB: 5, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 5, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.DIV, numB: 5, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.DIV, numB: 5, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 5, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 5, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 5, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.DIV, numB: 5, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 5, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.DIV, numB: 5, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 5, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.DIV, numB: 5, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 5, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.DIV, numB: 5, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.DIV, numB: 5, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 5, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question
];

export const divide10Questions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.DIV, numB: 10, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 10, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 10, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 10, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 10, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 10, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.DIV, numB: 10, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.DIV, numB: 10, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.DIV, numB: 10, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.DIV, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 110, sign: mathSymbols.DIV, numB: 10, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 120, sign: mathSymbols.DIV, numB: 10, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 10, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 10, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 10, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 10, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 10, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 10, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.DIV, numB: 10, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.DIV, numB: 10, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.DIV, numB: 10, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.DIV, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 110, sign: mathSymbols.DIV, numB: 10, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 120, sign: mathSymbols.DIV, numB: 10, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question
];

export const oddEvenQuestions: types.Question[] = [
  {
    numA: 1, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 2, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 3, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 4, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 5, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 6, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 7, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 8, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 9, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 10, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 11, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 12, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 13, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 14, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 15, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 16, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 17, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 18, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 19, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 20, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 21, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 22, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 23, action: 'Odd or even?', answer: 'Odd', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question,
  {
    numA: 24, action: 'Odd or even?', answer: 'Even', format: types.Format.OddOrEven, hint: types.Hint.ODD_EVEN_TEN_FRAME
  } as types.Question
];

export const twoTimesTableQuestions: types.Question[] = [
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 2, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 2, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 2, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 2, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 2, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 2, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 1, answer: 2, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 3, answer: 6, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 4, answer: 8, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 5, answer: 10, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 6, answer: 12, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 7, answer: 14, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 8, answer: 16, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 9, answer: 18, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 10, answer: 20, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 11, answer: 22, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 12, answer: 24, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 1, answer: 2, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 2, answer: 4, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 3, answer: 6, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 4, answer: 8, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 5, answer: 10, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 6, answer: 12, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 7, answer: 14, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 8, answer: 16, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 9, answer: 18, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 10, answer: 20, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 11, answer: 22, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.DIV, numB: 12, answer: 24, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 2, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 2, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 1, answer: 2, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 2, answer: 4, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 3, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 4, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 5, answer: 10, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 7, answer: 14, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 9, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 20, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 11, answer: 22, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLY_TWO_TEN_FRAME
  } as types.Question
];

export const threeTimesTableQuestions: types.Question[] = [
  {
    numA: 3, sign: mathSymbols.DIV, numB: 3, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 3, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 3, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 3, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.DIV, numB: 3, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 3, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.DIV, numB: 3, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 3, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.DIV, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 3, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.DIV, numB: 3, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 3, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 3, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 3, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 3, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 3, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.DIV, numB: 3, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 3, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.DIV, numB: 3, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 3, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.DIV, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 3, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.DIV, numB: 3, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 3, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 1, answer: 3, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 3, answer: 9, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 4, answer: 12, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 5, answer: 15, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 6, answer: 18, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 7, answer: 21, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 8, answer: 24, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 9, answer: 27, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 10, answer: 30, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 11, answer: 33, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 12, answer: 36, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 1, answer: 3, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 2, answer: 6, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 3, answer: 9, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 4, answer: 12, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 5, answer: 15, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 6, answer: 18, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 7, answer: 21, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 8, answer: 24, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 9, answer: 27, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 10, answer: 30, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 11, answer: 33, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.DIV, numB: 12, answer: 36, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 3, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 3, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 6, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 1, answer: 3, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 2, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 3, answer: 9, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 4, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 5, answer: 15, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 6, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 7, answer: 21, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 8, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 9, answer: 27, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 10, answer: 30, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 11, answer: 33, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const fourTimesTableQuestions: types.Question[] = [
  {
    numA: 4, sign: mathSymbols.DIV, numB: 4, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 4, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 4, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 4, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 4, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 4, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.DIV, numB: 4, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.DIV, numB: 4, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 4, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 4, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.DIV, numB: 4, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 4, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 4, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 4, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 4, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 4, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 4, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 4, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.DIV, numB: 4, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.DIV, numB: 4, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 4, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 4, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.DIV, numB: 4, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 4, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 1, answer: 4, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 3, answer: 12, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 4, answer: 16, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 5, answer: 20, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 6, answer: 24, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 7, answer: 28, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 8, answer: 32, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 9, answer: 36, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 10, answer: 40, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 11, answer: 44, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 12, answer: 48, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 1, answer: 4, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 2, answer: 8, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 3, answer: 12, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 4, answer: 16, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 5, answer: 20, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 6, answer: 24, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 7, answer: 28, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 8, answer: 32, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 9, answer: 36, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 10, answer: 40, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 11, answer: 44, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.DIV, numB: 12, answer: 48, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 4, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 4, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 8, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 12, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 16, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 1, answer: 4, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 2, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 3, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 4, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 5, answer: 20, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 6, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 7, answer: 28, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 8, answer: 32, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 9, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 10, answer: 40, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 11, answer: 44, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 12, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const fiveTimesTableQuestions: types.Question[] = [
  {
    numA: 5, sign: mathSymbols.DIV, numB: 5, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 5, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.DIV, numB: 5, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 5, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.DIV, numB: 5, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 5, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.DIV, numB: 5, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 5, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.DIV, numB: 5, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 5, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.DIV, numB: 5, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 5, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 5, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 5, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 15, sign: mathSymbols.DIV, numB: 5, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 5, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 25, sign: mathSymbols.DIV, numB: 5, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 5, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.DIV, numB: 5, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 5, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.DIV, numB: 5, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 5, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.DIV, numB: 5, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 5, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 1, answer: 5, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 3, answer: 15, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 4, answer: 20, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 5, answer: 25, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 6, answer: 30, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 7, answer: 35, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 8, answer: 40, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 9, answer: 45, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 10, answer: 50, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 11, answer: 55, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 12, answer: 60, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 1, answer: 5, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 2, answer: 10, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 3, answer: 15, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 4, answer: 20, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 5, answer: 25, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 6, answer: 30, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 7, answer: 35, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 8, answer: 40, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 9, answer: 45, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 10, answer: 50, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 11, answer: 55, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.DIV, numB: 12, answer: 60, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation6, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation7, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 1, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 2, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 15, answer: 3, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 20, answer: 4, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 5, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation5, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 5, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 10, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 15, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 20, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 25, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation8, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation1, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation2, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation3, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 1, answer: 5, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 2, answer: 10, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 3, answer: 15, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 4, answer: 20, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 5, answer: 25, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 6, answer: 30, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 7, answer: 35, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 8, answer: 40, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 9, answer: 45, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 10, answer: 50, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 11, answer: 55, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 12, answer: 60, format: types.Format.Equation4, hint: types.Hint.FIVE_DICE_TEN_FRAME
  } as types.Question
];

export const sixTimesTableQuestions: types.Question[] = [
  {
    numA: 6, sign: mathSymbols.DIV, numB: 6, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 6, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 6, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 6, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 6, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 6, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.DIV, numB: 6, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 6, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.DIV, numB: 6, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 6, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.DIV, numB: 6, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 6, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 6, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 6, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 6, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 6, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 6, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 6, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.DIV, numB: 6, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 6, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.DIV, numB: 6, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 6, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.DIV, numB: 6, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 6, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 1, answer: 6, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 3, answer: 18, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 4, answer: 24, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 5, answer: 30, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 6, answer: 36, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 7, answer: 42, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 8, answer: 48, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 9, answer: 54, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 10, answer: 60, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 11, answer: 66, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 12, answer: 72, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 1, answer: 6, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 2, answer: 12, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 3, answer: 18, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 4, answer: 24, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 5, answer: 30, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 6, answer: 36, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 7, answer: 42, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 8, answer: 48, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 9, answer: 54, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 10, answer: 60, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 11, answer: 66, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.DIV, numB: 12, answer: 72, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 18, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 24, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 30, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 6, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 6, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 12, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 18, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 24, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 30, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 36, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 1, answer: 6, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 2, answer: 12, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 3, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 4, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 5, answer: 30, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 6, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 7, answer: 42, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 8, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 9, answer: 54, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 10, answer: 60, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 11, answer: 66, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 12, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const sevenTimesTableQuestions: types.Question[] = [
  {
    numA: 7, sign: mathSymbols.DIV, numB: 7, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 7, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.DIV, numB: 7, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.DIV, numB: 7, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.DIV, numB: 7, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.DIV, numB: 7, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.DIV, numB: 7, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.DIV, numB: 7, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.DIV, numB: 7, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.DIV, numB: 7, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.DIV, numB: 7, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.DIV, numB: 7, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 7, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 14, sign: mathSymbols.DIV, numB: 7, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 21, sign: mathSymbols.DIV, numB: 7, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 28, sign: mathSymbols.DIV, numB: 7, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 35, sign: mathSymbols.DIV, numB: 7, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 42, sign: mathSymbols.DIV, numB: 7, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 49, sign: mathSymbols.DIV, numB: 7, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.DIV, numB: 7, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.DIV, numB: 7, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.DIV, numB: 7, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.DIV, numB: 7, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.DIV, numB: 7, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 1, answer: 7, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 2, answer: 14, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 3, answer: 21, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 4, answer: 28, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 5, answer: 35, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 6, answer: 42, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 7, answer: 49, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 8, answer: 56, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 9, answer: 63, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 10, answer: 70, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 11, answer: 77, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 12, answer: 84, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 1, answer: 7, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 2, answer: 14, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 3, answer: 21, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 4, answer: 28, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 5, answer: 35, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 6, answer: 42, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 7, answer: 49, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 8, answer: 56, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 9, answer: 63, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 10, answer: 70, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 11, answer: 77, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.DIV, numB: 12, answer: 84, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 14, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 21, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 28, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 35, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 42, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 7, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 7, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 14, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 21, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 28, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 35, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 42, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 49, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 1, answer: 7, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 2, answer: 14, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 3, answer: 21, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 4, answer: 28, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 5, answer: 35, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 6, answer: 42, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 7, answer: 49, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 8, answer: 56, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 9, answer: 63, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 10, answer: 70, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 11, answer: 77, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 12, answer: 84, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const eightTimesTableQuestions: types.Question[] = [
  {
    numA: 8, sign: mathSymbols.DIV, numB: 8, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 8, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 8, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.DIV, numB: 8, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 8, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 8, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.DIV, numB: 8, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.DIV, numB: 8, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 8, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.DIV, numB: 8, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.DIV, numB: 8, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.DIV, numB: 8, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 8, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 16, sign: mathSymbols.DIV, numB: 8, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 8, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 32, sign: mathSymbols.DIV, numB: 8, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 8, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 8, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 56, sign: mathSymbols.DIV, numB: 8, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 64, sign: mathSymbols.DIV, numB: 8, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 8, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.DIV, numB: 8, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.DIV, numB: 8, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.DIV, numB: 8, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 1, answer: 8, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 16, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 3, answer: 24, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 4, answer: 32, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 5, answer: 40, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 6, answer: 48, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 7, answer: 56, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 8, answer: 64, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 9, answer: 72, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 10, answer: 80, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 11, answer: 88, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 12, answer: 96, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 1, answer: 8, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 2, answer: 16, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 3, answer: 24, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 4, answer: 32, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 5, answer: 40, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 6, answer: 48, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 7, answer: 56, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 8, answer: 64, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 9, answer: 72, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 10, answer: 80, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 11, answer: 88, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.DIV, numB: 12, answer: 96, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 16, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 24, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 32, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 40, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 48, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 56, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 8, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 8, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 16, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 24, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 32, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 40, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 48, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 56, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 64, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 1, answer: 8, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 2, answer: 16, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 3, answer: 24, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 4, answer: 32, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 5, answer: 40, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 6, answer: 48, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 7, answer: 56, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 8, answer: 64, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 9, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 10, answer: 80, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 11, answer: 88, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 12, answer: 96, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const nineTimesTableQuestions: types.Question[] = [
  {
    numA: 9, sign: mathSymbols.DIV, numB: 9, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 9, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.DIV, numB: 9, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 9, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.DIV, numB: 9, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.DIV, numB: 9, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.DIV, numB: 9, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 9, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.DIV, numB: 9, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.DIV, numB: 9, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.DIV, numB: 9, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 108, sign: mathSymbols.DIV, numB: 9, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 9, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 18, sign: mathSymbols.DIV, numB: 9, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 27, sign: mathSymbols.DIV, numB: 9, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 9, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 45, sign: mathSymbols.DIV, numB: 9, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 54, sign: mathSymbols.DIV, numB: 9, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 63, sign: mathSymbols.DIV, numB: 9, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 9, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 81, sign: mathSymbols.DIV, numB: 9, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.DIV, numB: 9, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.DIV, numB: 9, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 108, sign: mathSymbols.DIV, numB: 9, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 1, answer: 9, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 2, answer: 18, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 3, answer: 27, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 4, answer: 36, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 5, answer: 45, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 6, answer: 54, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 7, answer: 63, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 8, answer: 72, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 9, answer: 81, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 10, answer: 90, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 11, answer: 99, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 12, answer: 108, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 1, answer: 9, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 2, answer: 18, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 3, answer: 27, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 4, answer: 36, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 5, answer: 45, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 6, answer: 54, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 7, answer: 63, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 8, answer: 72, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 9, answer: 81, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 10, answer: 90, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 11, answer: 99, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.DIV, numB: 12, answer: 108, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation6, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation7, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 1, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 18, answer: 2, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 27, answer: 3, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 36, answer: 4, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 45, answer: 5, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 54, answer: 6, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 63, answer: 7, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 72, answer: 8, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 9, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation5, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 9, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 18, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 27, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 36, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 45, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 54, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 63, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 72, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 81, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation8, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation1, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation2, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation3, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 1, answer: 9, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 2, answer: 18, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 3, answer: 27, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 4, answer: 36, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 5, answer: 45, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 6, answer: 54, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 7, answer: 63, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 8, answer: 72, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 9, answer: 81, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 10, answer: 90, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 11, answer: 99, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 12, answer: 108, format: types.Format.Equation4, hint: types.Hint.MULTIPLICATION_ARRAY
  } as types.Question
];

export const tenTimesTableQuestions: types.Question[] = [
  {
    numA: 10, sign: mathSymbols.DIV, numB: 10, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 10, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 10, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 10, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 10, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 10, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.DIV, numB: 10, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.DIV, numB: 10, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.DIV, numB: 10, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.DIV, numB: 10, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 110, sign: mathSymbols.DIV, numB: 10, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 120, sign: mathSymbols.DIV, numB: 10, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 10, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 20, sign: mathSymbols.DIV, numB: 10, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 30, sign: mathSymbols.DIV, numB: 10, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 40, sign: mathSymbols.DIV, numB: 10, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 50, sign: mathSymbols.DIV, numB: 10, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 10, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 70, sign: mathSymbols.DIV, numB: 10, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 80, sign: mathSymbols.DIV, numB: 10, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 90, sign: mathSymbols.DIV, numB: 10, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 100, sign: mathSymbols.DIV, numB: 10, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 110, sign: mathSymbols.DIV, numB: 10, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 120, sign: mathSymbols.DIV, numB: 10, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 1, answer: 10, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 20, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 3, answer: 30, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 4, answer: 40, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 5, answer: 50, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 6, answer: 60, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 7, answer: 70, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 8, answer: 80, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 9, answer: 90, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 10, answer: 100, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 11, answer: 110, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 12, answer: 120, format: types.Format.Equation6, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 1, answer: 10, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 2, answer: 20, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 3, answer: 30, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 4, answer: 40, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 5, answer: 50, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 6, answer: 60, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 7, answer: 70, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 8, answer: 80, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 9, answer: 90, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 10, answer: 100, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 11, answer: 110, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.DIV, numB: 12, answer: 120, format: types.Format.Equation8, hint: types.Hint.DIVIDE_BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation6, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation7, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 1, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 20, answer: 2, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 30, answer: 3, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 40, answer: 4, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 50, answer: 5, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 60, answer: 6, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 70, answer: 7, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 80, answer: 8, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 90, answer: 9, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 10, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 10, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 20, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 30, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 40, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 50, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 60, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 70, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 80, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 90, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 100, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation1, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation2, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation3, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 1, answer: 10, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 2, answer: 20, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 3, answer: 30, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 4, answer: 40, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 5, answer: 50, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 6, answer: 60, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 7, answer: 70, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 8, answer: 80, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 9, answer: 90, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 10, answer: 100, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 11, answer: 110, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 12, answer: 120, format: types.Format.Equation4, hint: types.Hint.BASE_TEN
  } as types.Question
];

export const elevenTimesTableQuestions: types.Question[] = [
  {
    numA: 11, sign: mathSymbols.DIV, numB: 11, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 11, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.DIV, numB: 11, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.DIV, numB: 11, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.DIV, numB: 11, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.DIV, numB: 11, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.DIV, numB: 11, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.DIV, numB: 11, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.DIV, numB: 11, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 110, sign: mathSymbols.DIV, numB: 11, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 121, sign: mathSymbols.DIV, numB: 11, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 132, sign: mathSymbols.DIV, numB: 11, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 11, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 22, sign: mathSymbols.DIV, numB: 11, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 33, sign: mathSymbols.DIV, numB: 11, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 44, sign: mathSymbols.DIV, numB: 11, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 55, sign: mathSymbols.DIV, numB: 11, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 66, sign: mathSymbols.DIV, numB: 11, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 77, sign: mathSymbols.DIV, numB: 11, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 88, sign: mathSymbols.DIV, numB: 11, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 99, sign: mathSymbols.DIV, numB: 11, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 110, sign: mathSymbols.DIV, numB: 11, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 121, sign: mathSymbols.DIV, numB: 11, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 132, sign: mathSymbols.DIV, numB: 11, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 1, answer: 11, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 2, answer: 22, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 3, answer: 33, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 4, answer: 44, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 5, answer: 55, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 6, answer: 66, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 7, answer: 77, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 8, answer: 88, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 9, answer: 99, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 10, answer: 110, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 11, answer: 121, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 12, answer: 132, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 1, answer: 11, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 2, answer: 22, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 3, answer: 33, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 4, answer: 44, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 5, answer: 55, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 6, answer: 66, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 7, answer: 77, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 8, answer: 88, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 9, answer: 99, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 10, answer: 110, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 11, answer: 121, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.DIV, numB: 12, answer: 132, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 1, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 22, answer: 2, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 33, answer: 3, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 44, answer: 4, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 55, answer: 5, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 66, answer: 6, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 77, answer: 7, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 88, answer: 8, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 99, answer: 9, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 110, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 11, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 11, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 22, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 33, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 44, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 55, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 66, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 77, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 88, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 99, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 110, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 121, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 1, answer: 11, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 2, answer: 22, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 3, answer: 33, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 4, answer: 44, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 5, answer: 55, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 6, answer: 66, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 7, answer: 77, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 8, answer: 88, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 9, answer: 99, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 10, answer: 110, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 11, answer: 121, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 12, answer: 132, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question
];

export const twelveTimesTableQuestions: types.Question[] = [
  {
    numA: 12, sign: mathSymbols.DIV, numB: 12, answer: 1, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 12, answer: 2, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 12, answer: 3, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 12, answer: 4, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 12, answer: 5, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 12, answer: 6, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.DIV, numB: 12, answer: 7, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.DIV, numB: 12, answer: 8, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 108, sign: mathSymbols.DIV, numB: 12, answer: 9, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 120, sign: mathSymbols.DIV, numB: 12, answer: 10, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 132, sign: mathSymbols.DIV, numB: 12, answer: 11, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 144, sign: mathSymbols.DIV, numB: 12, answer: 12, format: types.Format.Equation1, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 12, answer: 1, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 24, sign: mathSymbols.DIV, numB: 12, answer: 2, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 36, sign: mathSymbols.DIV, numB: 12, answer: 3, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 48, sign: mathSymbols.DIV, numB: 12, answer: 4, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 60, sign: mathSymbols.DIV, numB: 12, answer: 5, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 72, sign: mathSymbols.DIV, numB: 12, answer: 6, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 84, sign: mathSymbols.DIV, numB: 12, answer: 7, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 96, sign: mathSymbols.DIV, numB: 12, answer: 8, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 108, sign: mathSymbols.DIV, numB: 12, answer: 9, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 120, sign: mathSymbols.DIV, numB: 12, answer: 10, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 132, sign: mathSymbols.DIV, numB: 12, answer: 11, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 144, sign: mathSymbols.DIV, numB: 12, answer: 12, format: types.Format.Equation2, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 1, answer: 12, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 24, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 3, answer: 36, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 4, answer: 48, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 5, answer: 60, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 6, answer: 72, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 7, answer: 84, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 8, answer: 96, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 9, answer: 108, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 10, answer: 120, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 11, answer: 132, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 12, answer: 144, format: types.Format.Equation6, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 1, answer: 12, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 2, answer: 24, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 3, answer: 36, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 4, answer: 48, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 5, answer: 60, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 6, answer: 72, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 7, answer: 84, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 8, answer: 96, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 9, answer: 108, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 10, answer: 120, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 11, answer: 132, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.DIV, numB: 12, answer: 144, format: types.Format.Equation8, hint: types.Hint.DIVIDE_ARRAY
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation6, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation7, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 1, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 24, answer: 2, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 36, answer: 3, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 48, answer: 4, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 60, answer: 5, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 72, answer: 6, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 84, answer: 7, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 96, answer: 8, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 108, answer: 9, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 120, answer: 10, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 132, answer: 11, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 12, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation5, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 1, sign: mathSymbols.MULT, numB: 12, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 2, sign: mathSymbols.MULT, numB: 24, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 3, sign: mathSymbols.MULT, numB: 36, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 4, sign: mathSymbols.MULT, numB: 48, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 5, sign: mathSymbols.MULT, numB: 60, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 6, sign: mathSymbols.MULT, numB: 72, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 7, sign: mathSymbols.MULT, numB: 84, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 8, sign: mathSymbols.MULT, numB: 96, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 9, sign: mathSymbols.MULT, numB: 108, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 10, sign: mathSymbols.MULT, numB: 120, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 11, sign: mathSymbols.MULT, numB: 132, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 144, answer: 12, format: types.Format.Equation8, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation1, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation2, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation3, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 1, answer: 12, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 2, answer: 24, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 3, answer: 36, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 4, answer: 48, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 5, answer: 60, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 6, answer: 72, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 7, answer: 84, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 8, answer: 96, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 9, answer: 108, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 10, answer: 120, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 11, answer: 132, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question,
  {
    numA: 12, sign: mathSymbols.MULT, numB: 12, answer: 144, format: types.Format.Equation4, hint: types.Hint.BASE_TEN_MULTIPLICATION
  } as types.Question
];